<template>
  <div style='background:white;' class='' v-loading='loading'>
  
    <div class='gPageBorder'>
      <div style='width:calc(100% - 24px);height:100%;background: none;padding-left:24px;'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{config ? config.launchername : ''}}</button>
        </div>
        <div style='height:30px;'>
          <table class='dt-launch'>
            <tr style=''>
              <td style='width:15%;'>
                <label class='dt-word-title'>{{$t('app_version')}}：</label>
                <label class='dt-word-main'>{{config? config.version : ''}}</label>
              </td>
              <td style='width:15%;'>
                <label class='dt-word-title'>{{$t('app_verTag')}}：</label>
                <label class='dt-word-main'>{{config? config.versioncode : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_package')}}：</label>
                <label class='dt-word-main'>{{config? config.packagename : ''}}</label>
              </td>
              <td>
              </td>
             
            </tr>
          </table>
        </div>
        <div style='background:none;min-height:10px;display:flex;display:-webkit-flex;'>
          <div class='dt-word-title' style='display:inline-block;min-width:70px;'>
            launch{{$t('app_ss')}}：
          </div>
          <div class='dt-word-main' style='display:inline-block;position:relative;background:none;margin: 0 24px 24px 0;'>
            <pre>{{config.launcherdesc}}</pre>
          </div>
        </div>

    

      </div>
    </div>
     
    <div class='gPageBorder gTopMg' v-show='captures? captures.length > 0 : false'  style=''>
      
      <p class='gCtColor  gPTitle' style=''>{{$t('app_screenShot')}} </p>
      <div>
        <img onerror="this.src='/static/img/df-h.png'" v-for='item in captures' class='gBorder' style='width:180px;height:320px;margin:24px 0 24px 24px;border-radius:4px;' :src="imgFullUrl(item)">
      </div>
  
    </div>

    <div class='gPageBorder gTopMg' v-show="config.status === '2'" style=''>
      
      <p class='gCtColor gPTitle' style=''>{{$t('app_hisVer')}} </p>

      <el-button  v-show="showUploadNew"  @click='uploadNew' type='primary' style='margin: 24px 0 24px 24px' class=''>{{$t('app_ulNew')}}</el-button>
      
      <el-table
        :data="tableData"
        border
        style="width: 100%;">
        <el-table-column
          header-align='center'
          align='center'
          prop="launchername"
          :label="'launcher' + $t('app_name')"
          width="">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="version"
          width=''
          :label="$t('app_version')">
        </el-table-column>
       
        <el-table-column
          header-align='center'
          align='center'
          fformatter="dateFormat"
          prop="uploadtime"
          width='170'
          :label="$t('app_createTime')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop=""
          width='80'
          :label="$t('app_operate')">
          <template slot-scope='scope'>
            <!-- <el-button v-show="config.isoperate === 0" type=text @click='delHis(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text' v-show="config.isoperate === 0" @click='delHis(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  

  </div>
</template>

<style>
  .dt-word-main{color:rgb(72,87,106)}
  .dt-word-title{color:#99A9BF;}
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
  }

  .dt-launch{width:100%;height:100%;background:none;}
    .dt-launch td{width:20%;}

  /* upload */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  /* upload */
  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import mm from 'moment'
  import df from '../../../assets/df.png'
  export default {
    data () {
      return {
        config: '',
        captures: [],
        loading: 0,
        tableData: []
      }
    },
    computed: {
      avtStyle () {
        var url = this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : require('../../../assets/df.png')
        
        return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')'
      },
      showUploadNew () {
        //console.log('ccc', this.config.data)
        if (this.config) {
          if (this.config.isoperate === 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {

      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {
        this.getDevices()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getDevices()
      },
     


      delHis (row) {
        
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = 1
          this.$delLauncherHistory(row.versionid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getHistory()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
          
        }).catch(() => {
        })
        
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
          //return path
        } else {
          return ''
        }
      },

      getHistory () {
        if (this.config.status !== '2') {
          return
        }
        this.loading = 1
        this.$launcherHistory(this.config.launcherid, (res) => {
          console.log('his', res)
          this.loading = 0
          if (res.status === 200) {
            this.tableData = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
        
        
      },
      uploadNew () {
        // this.$t('menu.sysManageSub.launchNewVer')
        var obj = {type: 2, data: this.config}
        var key = 'launcherEdit'
        this.$setWObj(key, obj)
        this.$router.push({path: '/launch-newver'})
      },
      init () {
        this.config = this.$getWObj().launcherDetail
        this.setCapturesArr(this.config.launcherimg)
        this.getHistory()
      },
      setCapturesArr (strs) {
        if (strs) {
          var arr = strs.split(',')
          this.captures = arr
        }
      }
    },
    mounted () {
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// detail.vue?67eeb354